import WrapperService from "@/modules/core/services/wrapper-service";

const serviceName = "OdtPdf-Service: ";
const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/odtpdf"



export default class PdfGeneratorService {

    /**
     * Calls a backend controller method to create a POA pdf document for the given
     * facility, and signs it.
     * @param facilityUID for the given facility
     * @param senderEMailAddress Sender E-Mail Address
     * @param senderLastName Sender Last Name which appears in Sproof-Portal
     * @param successF
     * @param errorF
     * @returns {Promise<void>}
     */
    static async createAndSignPOA(facilityUID, senderEMailAddress, senderLastName,successF, errorF) {
        let formData = new FormData();
        formData.append("senderEmailAddress", senderEMailAddress);
        formData.append("senderName", senderLastName);
        return WrapperService.put(API_URL + "/" + facilityUID, formData, serviceName, successF, errorF);
    }
}